import { render } from "./NewsTitle.vue?vue&type=template&id=7be613eb&scoped=true"
import script from "./NewsTitle.vue?vue&type=script&lang=js"
export * from "./NewsTitle.vue?vue&type=script&lang=js"

import "./NewsTitle.vue?vue&type=style&index=0&id=7be613eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7be613eb"]])

export default __exports__